import Repository from "./Repository";

const CREATE = "create";
const CREATE_SMS = "/controlCenter/ccSms/create";
const GETALLSMS = "/controlCenter/ccSms/getAll";
const GETALL = "getAll";

export default {
  create(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  createSms(payload) {
    return Repository.post(CREATE_SMS, payload);
  },
  getAll(payload) {
    return Repository.post(transformRoute(GETALL), payload);
  },
  getAllSms(payload) {
    return Repository.post(GETALLSMS, payload);
  },
};

const transformRoute = (route) => {
  return `/controlCenter/ccEmail/${route}`;
};
